module.exports = __webpack_public_path__ + "static/media/dot.bf834404.svg";